import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_onboarding-category_page_highlighted_product-view';
/**
 * this event tracks whether a retailer who navigated back to the category page with the &quot;return to results&quot; product page button sees their product highlighted on the first page.
 */
export function trackRetailerOnboardingCategoryPageHighlightedProductView(productWasHighlighted) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { productWasHighlighted },
    });
}
